import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router'
import Home from '../views/home/home.vue'

import Experience from '../views/experience/experience.vue'

const routes = [
  {
    path: '/',
    component: Home,
    redirect: window.__POWERED_BY_QIANKUN__ ? '/experience' : '/home',
  },
  {
    path: '/home',
    name: 'Home',
    component: () =>
      import(/* webpackChunkName: "home" */ '../views/home/home.vue'),
    meta: {
      title: 'TwinsMT | 孪生引擎官网',
    },
  },
  {
    path: '/mobile',
    name: 'Mobile',
    component: () =>
      import(/* webpackChunkName: "mobile" */ '../views/mobile/index.vue'),
    meta: {
      title: 'TwinsMT | 孪生引擎官网',
    },
  },
  {
    path: '/market',
    name: 'Market',
    component: () =>
      import(/* webpackChunkName: "market" */ '../views/market/market.vue'),
    meta: {
      title: '引擎仓库 | TwinsMT孪生引擎',
    },
  },
  {
    path: '/detail',
    name: 'Detail',
    component: () =>
      import(/* webpackChunkName: "detail" */ '../views/detail/detail.vue'),
  },
  {
    path: '/lab',
    name: 'Lab',
    component: () =>
      import(/* webpackChunkName: "lab" */ '../views/lab/lab.vue'),
  },
  {
    path: '/my',
    name: 'My',
    component: () =>
      import(/* webpackChunkName: "market" */ '../views/my/my.vue'),
    meta: {
      title: '我的TwinsMT | TwinsMT孪生引擎',
    },
  },
  {
    path: '/status',
    name: 'Status',
    component: () =>
      import(/* webpackChunkName: "status" */ '../views/status/status.vue'),
  },
  {
    path: '/upload',
    name: 'Upload',
    component: () =>
      import(/* webpackChunkName: "upload" */ '../views/upload/upload.vue'),
  },
  {
    path: '/preview',
    name: 'Preview',
    component: () =>
      import(/* webpackChunkName: "preview" */ '../views/preview/preview.vue'),
  },
  {
    path: '/experience',
    name: 'Experience',
    component: Experience,
    meta: {
      title: '快速体验 | TwinsMT孪生引擎',
    },
  },
  {
    path: '/experienceDocList',
    name: 'ExperienceDocList',
    component: () =>
      import(
        /* webpackChunkName: "experienceDocList" */ '../views/experience/docTranslationList/index.vue'
      ),
    meta: {
      title: '体验文档记录 | TwinsMT孪生引擎',
    },
  },
  {
    path: '/experiencePreview',
    name: 'ExperiencePreview',
    component: () =>
      import(
        /* webpackChunkName: "newPreview" */ '../views/experiencePreview/index.vue'
      ),
  },
  {
    path: '/translate',
    name: 'Translate',
    component: () =>
      import(
        /* webpackChunkName: "translate" */ '../views/translate/index.vue'
      ),
    meta: {
      title: '快速体验 | TwinsMT孪生引擎',
    },
  },
  {
    path: '/create',
    name: 'Create',
    component: () =>
      import(/* webpackChunkName: "my" */ '../views/create/index.vue'),
    meta: {
      title: 'TwinsMT创建 | TwinsMT孪生引擎',
    },
  },
  {
    path: '/overview',
    name: 'Overview',
    component: () =>
      import(/* webpackChunkName: "overview" */ '../views/overview/index.vue'),
    meta: {
      title: 'TwinsMT概况 | TwinsMT孪生引擎',
    },
  },
  {
    path: '/subData',
    name: 'SubData',
    component: () =>
      import(/* webpackChunkName: "subData" */ '../views/subData/index.vue'),
    meta: {
      title: '我的引擎 | 上传语料',
    },
  },
  {
    path: '/together',
    name: 'together',
    component: () =>
      import(/* webpackChunkName: "subData" */ '../views/together/index.vue'),
    children: [
      {
        path: 'upload',
        name: 'Upload',
        component: () =>
          import(
            /* webpackChunkName: "subData" */ '../views/together/upload/index.vue'
          ),
      },
      {
        path: 'uploadSuccess',
        name: 'UploadSuccess',
        component: () =>
          import(
            /* webpackChunkName: "subData" */ '../views/together/uploadSuccess/index.vue'
          ),
      },
    ],
    meta: {
      title: '我的引擎 | 上传语料',
    },
  },
  {
    path: '/personalDataView',
    name: 'PersonalDataView',
    component: () =>
      import(
        /* webpackChunkName: "personalDataView" */ '../views/personalDataView/index.vue'
      ),
    meta: {
      title: 'TwinsMT概况 | TwinsMT孪生引擎',
    },
  },
  {
    path: '/freeDetail',
    name: 'FreeDetail',
    component: () =>
      import(
        /* webpackChunkName: "freeDetail" */ '../views/freeDetail/index.vue'
      ),
    meta: {
      title: 'TwinsMT概况 | TwinsMT孪生引擎',
    },
  },
  // {
  //   path: '/:catchAll(.*)',
  //   redirect: '/home'
  // },
]

const origin = window.location.origin
let microBase = ''

if (window.__POWERED_BY_QIANKUN__) {
  // qiankun子应用模式
  if (origin.includes('open')) {
    // 开发平台接入子应用
    microBase = '/app/micro-app/tw/'
  } else {
    // lsp接入子应用
    microBase = '/twApp/'
  }
} else {
  // 独立部署模式
  microBase = ''
}

const router = createRouter({
  history: createWebHistory(microBase),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    if (to.path == '/detail') {
      window.scrollTo(0, 0)
    }
  },
})

export default router
